{
  "title": "Crear nueva cuenta",
  "selectAccount": "Seleccionar tipo de cuenta",
  "accountHolder": "Titular de la cuenta",
  "accountSummary": {
    "added": "Ha añadido correctamente una nueva cuenta",
    "failed": "No se ha podido añadir una nueva cuenta.",
    "subAccMsg": "Conectemos esta cuenta a una subcuenta"
  },
  "actions": {
    "createNewAccount": "Crear nueva cuenta",
    "createSubAccount": "Crear subcuenta"
  },
  "govFundOptions": {
    "ADDITIONAL_CESG": "CESG adicional",
    "BASIC_CESG": "Subvención básica de ahorro para la educación en Canadá",
    "CLB": "Bono de aprendizaje de Canadá"
  },
  "isTransferredFromAnotherInstitution": "Transferido desde otra institución",
  "yes": "Sí",
  "no": "No",
  "sourceOfFundsOptions": {
    "SELF": "Uno mismo",
    "SPOUSE": "Esposo/a",
    "USA_EMPLOYMENT_WAGES": " Salarios laborales",
    "USA_INHERITANCE_TRUST": " Herencia / Fideicomiso",
    "USA_LOTTERY_GAMING": "Lotería / Juegos de azar",
    "USA_RETIREMENT_FUNDS": "Fondos de jubilación",
    "USA_INVESTMENTS": "Inversiones",
    "USA_SPOUSAL_PARENTAL_SUPPORT": "Manutención conyugal / parental",
    "USA_GIFT": "Regalo",
    "USA_SAVINGS": "Ahorros",
    "USA_UNEMPLOYMENT_DISABILITY": " Desempleo / Discapacidad",
    "USA_LEGAL_SETTLEMENT": "Acuerdo legal",
    "USA_OTHER": "Otros"
  },
  "sourceOfFunds": "Origen de los fondos",
  "jurisdiction": "Jurisdicción",
  "custodianAccountNumber": "Número de cuenta de custodio",
  "feeGridTitle": "Tabla de tarifas",
  "billingCycleTitle": "Ciclo de facturación",
  "householdClientGroup": "Hogar",
  "federal": "Federal",
  "messages": {
    "setUpSubAccount": "A continuación, configuraremos su subcuenta",
    "requireAffiliate": "Este tipo de cuenta requiere al menos 1 afiliado"
  },
  "outlineText": {
    "skipForSubAccount": "Omita por ahora y cree una subcuenta",
    "skipNow": "Omita por ahora"
  },
  "repCode": "Código de Representante"
}
